import * as React from 'react'
import '~/styles/page/write-logo.css'

interface WriteLogoProps {
  className?: string
}

const WriteLogo: React.FC<WriteLogoProps> = ({ className }) => {
  return (
    <svg
      id="eGgXFSmcNq71"
      className={className}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 -10 174 95"
      shapeRendering="geometricPrecision"
      textRendering="geometricPrecision"
      project-id="475fd3d58d2541e58a37dc0cb3d45801"
      export-id="e7ef36be71754502b59396d91e4e604f"
    >
      <path
        d="M2 44.7273C14.5 26.5 21.7737 17.4545 62.0579 18.8182C76.9947 18.8182 85.6337 3.88636 75.6368 2C64.6228 2.30303 47.5737 4.72727 30.8263 30.1818C28.5632 34.2727 31.1579 32.8636 47 31.5C62.8421 30.1364 46 38 46 38L40.3316 41.0909C40.3316 41.0909 38.521 42 34.4474 44.7273C30.3737 47.4545 29.0158 48.8182 26.3 52.4545C23.5842 56.0909 27.6579 57.4545 27.6579 57.4545C40.7842 59.2727 72.0158 48.3636 86.5 62"
        strokeWidth="3.2"
        strokeLinecap="round"
      />
      <path
        d="M70.4139 30.5C65.4139 32.8333 56.5 45 62 50C70 55 83.9139 28.8077 78.9139 26.5C72.4139 23.5 55 43 69 48.5C75 48.7647 84 44.5 88 30.5C92 16.5 84 42 81 48.5C78 55 98.5 26 102.106 27C104.5 27 91.5 47 95 50.5C100 54 106.252 35.5 112.252 30.5C112.252 33 103.606 43 107.414 50.5C115.414 58 131.606 27.3751 119.106 26C106.606 24.6249 108.5 53.5 120.5 48.5C124.5 46.8333 129 42 130.5 36"
        strokeWidth="3.2"
        strokeLinecap="round"
      />
      <path
        d="M131.5 26.5C131 41.5 127 50 129 50C140 45.5 145 21.5 145 21.5"
        strokeWidth="3.2"
        strokeLinecap="round"
      />
      <path
        d="M163.888 27.2673C155.596 26.5 148.096 32 144.596 43.1594C138.844 61.5 157.096 39.5 167.596 27C161.596 38 156.012 51.3618 160.487 51.3618C164.596 51.3618 169.071 45.5518 170.205 43.1594"
        strokeWidth="3.2"
        strokeLinecap="round"
      />
    </svg>
  )
}

export default WriteLogo
